// System API client (homelab telemetry, read-only). Mirrors FinanceService's
// auth pattern. The server computes `sinceBeat` + thresholds; payload is
// card-shaped (see SYSTEM in serga-os/data.js).

const API_BASE_URL = "https://api.serga.ba";

export interface SystemNode {
  id: string;
  name: string;
  code?: string;
  host?: string;
  role?: string;
  ip?: string;
  cores?: number;
  beatEvery?: number;
  sinceBeat: number;
  uptimeH?: number;
  players?: number;
  maxPlayers?: number;
  services: Array<{ name: string; port?: string; up: boolean }>;
  vitals?: { temp?: number; load?: number; disk?: number; mem?: number };
}

export interface SystemView {
  nodes: SystemNode[];
  staleAt: number;
  deadAt: number;
}

export class SystemService {
  private static authTokens: any = null;

  static setAuthTokens(tokens: any) {
    this.authTokens = tokens;
  }

  private static getAuthHeaders() {
    if (!this.authTokens?.idToken) {
      throw new Error("No authentication token available");
    }
    return {
      Authorization: `Bearer ${this.authTokens.idToken}`,
      "Content-Type": "application/json",
    };
  }

  /** Homelab status, or null when no node has reported yet (pending). */
  static async getSystem(): Promise<SystemView | null> {
    const res = await fetch(`${API_BASE_URL}/system`, { headers: this.getAuthHeaders() });
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    const data = await res.json();
    if (!data || data.pending) return null;
    return data as SystemView;
  }
}
